import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTBodyRow } from '@celebration/design-system/dist/lib/table-tbody-row';

export default createComponent({
    react: React,
    elementClass: ClbTableTBodyRow,
    tagName: ClbTableTBodyRow.tagName,
    events: ClbTableTBodyRow.events,
});
